// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"366af34a","228":"5f3751b5","451":"2cfebf10","841":"118ad3f7","855":"7e2f5752"}[chunkId] + ".chunk.js";
};